// @flow
import React from 'react';
import { track } from '../../helpers/Tracking/Analytics';

type Props = {
  children: any,
  isFooter?: boolean,
  openInNewTab?: boolean
};

const ZendeskLink = ({
  children,
  isFooter = false,
  openInNewTab = false
}: Props) => (
  <a
    onClick={() => {
      const eventName = isFooter ? 'click:web-footer:help' : 'click:nav:help';

      track(eventName, {
        page: window.location.pathname.toLowerCase()
      });
    }}
    href="https://help.justpark.com"
    target={openInNewTab ? '_blank' : null}
    rel="noopener noreferrer"
  >
    {children}
  </a>
);

export default ZendeskLink;
